function getUrlSplitRegex(url: string) {
  // if (url.indexOf("localhost:43000")) {
  //   return /http:\/\/localhost:43000\/(.*)\/(.*)/;
  // }
  return /https:\/\/report-view\.pocketsurvey\.co\.kr\/(.*)\/(.*)/;
};

export default getUrlSplitRegex;
